<template>
  <div class="pt-5">
    <v-textarea
    outlined
    :label="labelText"
    v-model="note"
    hide-details
  ></v-textarea>
  <v-btn
    color="primary"
    @click="updateNote(false)"
    :loading="savingNote"
    class="my-2"
    >
      Save Note
      <span>
        <v-icon light>save</v-icon>
      </span>
  </v-btn>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';

export default {

  name: 'FolderNote',
  data: () => ({
    note: '',
    imageFolder: null,
    savingNote: false,
    labelText: '',
  }),
  methods: {
    ...mapActions(['updateFolder', 'setNotification']),
    async updateNote() {
      if (!this.imageFolder) return;
      if (this.note === this.imageFolder.note) return;
      this.savingNote = true;
      const payload = {
        pid: this.imageFolder.project,
        cid: this.imageFolder.company,
        path: this.imageFolder.path,
        updates: {
          note: this.note,
        },
      };

      const response = await this.updateFolder(payload);

      if (response.status === 200) {
        const notification = {
          success: true,
          message: 'notes successfully updated.',
        };
        this.setNotification(notification);
      }
      this.savingNote = false;
    },
    initNote() {
      const imageFolder = this.allFolders.find((f) => f.path === this.currentImage.folder);
      this.imageFolder = imageFolder;
      this.note = imageFolder ? imageFolder.note : '';
      this.labelText = `Note - ${imageFolder ? imageFolder.path : ''}`;
    },
  },
  computed: {
    ...mapGetters(['currentImage', 'allFolders']),
  },
  mounted() {
    this.initNote();
  },
  watch: {
    currentImage() {
      if (this.$route.name !== 'ProcessedImages') return;
      this.initNote();
    },
  },
};
</script>
